import { isBuildPhase } from '@/constant/env';
import { FooterCategoriesProps } from '@/decodo/blocks/Footer/FooterCategories';
import { ImageStrapiProps } from '@/decodo/components/atoms/Image/ImageStrapi';

import { FooterContactsProps } from './FooterContacts';
import { cms } from '@/cms';
import { Footer } from './Footer';

export interface FooterStrapiProps {
  slug?: string;
  documentId?: string;
  footer?: {
    logo?: ImageStrapiProps;
    contacts?: FooterContactsProps['contacts'];
    categories?: FooterCategoriesProps['categories'];
  };
}

export default async function FooterStrapi({
  documentId,
}: {
  documentId: string;
}) {
  if (!documentId) {
    throw new Error('Document ID is required');
  }

  const { data } = await cms.getFooterByDocumentId(documentId);

  const footerData = data?.attributes?.footer;

  if (!footerData) {
    if (isBuildPhase) throw new Error(`Footer with ID ${documentId} not found`);
    return null;
  }

  return <Footer {...footerData} />;
}
